// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BgsO","col":"styles_col__21pAk"};